export default "__VITE_ASSET__oTE9MCpb__"